import {DotnetIcon, HtmlIcon, CssIcon, CsharpIcon, SqlIcon, JSIcon, AngularIcon} from '../assets/icons';

export const devSkills = {
    dotnetSkill: {
        id: 0,
        name: ".Net",
        icon: DotnetIcon,
        color: "secondary",
    },
    csharpSkill: {
        id: 1,
        name: "Csharp",
        icon: CsharpIcon,
        color: "secondary",
    },
    sqlSkill: {
        id: 2,
        name: "Sql",
        icon: SqlIcon,
        color: "info",
    },
     angularSkill: {
         id: 3,
         name: "Angular",
         icon: AngularIcon,
         color: "error",
     },
     jsSkill: {
         id: 4,
         name: "JavaScript",
         icon: JSIcon,
         color: "warning",
     }, 
    htmlSkill: {
        id: 5,
        name: "HTML",
        icon: HtmlIcon,
        color: "warning",
    },
    cssSkill: {
        id: 6,
        name: "CSS",
        icon: CssIcon,
        color: "info",
    },
    
   
    
};
